import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames';
import { Typography } from 'antd';
import { imgix } from '@/shared/utils/utils';
import './index.less';

interface StoreDirectoryCardProps {
  title: string;
  ourStory: string;
  addressCity: string;
  addressCountry: string;
  handle: string;
  avatarUrl?: string;
}

const { Paragraph, Title } = Typography;

const StoreDirectoryCard = ({ store }: { store: StoreDirectoryCardProps }) => {
  const { title, avatarUrl, ourStory, handle, addressCity, addressCountry } = store;
  const getStoreLocation = () => {
    if (addressCity && addressCity.length > 0) {
      return addressCity;
    }

    if (addressCountry && addressCountry.length > 0) {
      return addressCountry;
    }

    return '';
  };

  return (
    <Link className="store-directory-card" href={`/s/${handle}`}>
      <div className="avatar">
        <Image
          className={classNames('', {
            'spark-stone': !avatarUrl,
          })}
          src={avatarUrl ? imgix(avatarUrl, { h: 105, dpr: 2, q: 100 }) : '/images/spark-stone.png'}
          alt={avatarUrl ? 'avatar' : 'spark-stone'}
          width={105}
          height={105}
        />
      </div>
      <div className="inner">
        <Title level={3} ellipsis={{ rows: 1 }} className="name">
          {title}
        </Title>
        <span className="location" style={{ opacity: getStoreLocation() ? 1 : 0 }}>
          {getStoreLocation()}
        </span>
        <Paragraph className="bio" ellipsis={{ rows: 3 }}>
          {ourStory || ''}
        </Paragraph>
      </div>
      <span className="link-to-store">
        Visit Shop
        <Image src="/images/next_step.png" alt="next_step" width={8} height={8} />
      </span>
    </Link>
  );
};

export default StoreDirectoryCard;
